import * as serviceContext from '../services/serviceContext';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function getImportEvent(game, date) {
    try {
        const response = await serviceContext.get("feed/betfair/catalog/" + game + "/" + date + "/IN", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


export async function getActiveMarkets() {
    try {
        const response = await serviceContext.get("feed/betfair/eventcontrol", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function importEvents(data) {
    try {
        const response = await serviceContext.post("feed/betfair/eventcontrol", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};



export async function getEventData(event) {
    try {
        const response = await serviceContext.get("feed/betfair/event/" + event, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


export async function getUserEvents() {
    try {
        const response = await serviceContext.get("usermgnt/event/users", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getFilteredUserEvents(data) {
    try {
        const response = await serviceContext.post("usermgnt/event/users", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getHomeData() {
    const accData = JSON.parse(localStorage.getItem("accountData"));
    try {
        const response = await serviceContext.get(`${(!!accData && Object.keys(accData).length > 0) ? 'marketprovider' : 'delaymarkets'}/markets`, null, options);
        //const response = await serviceContext.get(`marketprovider/markets`, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};



export async function getHomeCurrentData() {
    const accData = JSON.parse(localStorage.getItem("accountData"));
    try {
        const response = await serviceContext.get(`${(!!accData && Object.keys(accData).length > 0) ? 'marketprovider' : 'delaymarkets'}/markets/current`, null, options);
        //const response = await serviceContext.get(`marketprovider/markets`, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getInPlayCurrentData() {
    const accData = JSON.parse(localStorage.getItem("accountData"));
    try {
        const response = await serviceContext.get(`${(!!accData && Object.keys(accData).length > 0) ? 'marketprovider' : 'delaymarkets'}/markets/live`, null, options);
        //const response = await serviceContext.get(`marketprovider/markets`, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getBaseHomeData() {
    const accData = JSON.parse(localStorage.getItem("accountData"));
    try {
        const response = await serviceContext.get(`${(!!accData && Object.keys(accData).length > 0) ? 'marketprovider' : 'delaymarkets'}/markets/current`, null, options);
        // const response = await serviceContext.get("marketprovider/markets/current", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getUserEventById(eventId) {
    try {
        const accData = JSON.parse(localStorage.getItem("accountData"));
        const response = await serviceContext.get(`${(!!accData && Object.keys(accData).length > 0) ? 'marketprovider' : 'delaymarkets'}/events/detail/${eventId}`, null, options);
        // const response = await serviceContext.get("marketprovider/events/detail/" + eventId, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getEventTreeListing() {
    try {
        const response = await serviceContext.get("usermgnt/event/eventtypes", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
}

export async function getMatchedBets(events) {
    try {
        const response = await serviceContext.post(ReportsURL + "bets/user/open/event", JSON.stringify(events), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
}

export async function getUnMatchedBets(events) {
    try {
        const response = await serviceContext.post("query/bets/unmatched", JSON.stringify(events), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
}
export async function getMarketsById(marketList) {
    try {
        const response = await serviceContext.get("marketprovider/markets/selected?marketids=" + marketList.toString(), null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getEventScore(evt) {
    try {
        const response = await serviceContext.get("score/competitions?after=none&has_live_signal=true&competition_id=" + evt, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
}

export async function getEventMktMessages(evt) {
    try {
        const response = await serviceContext.get("notification/marketalert/" + evt, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
}

export async function getHomeDataByEventId(eventTypeId) {
    const accData = JSON.parse(localStorage.getItem("accountData"));
    try {
        const response = await serviceContext.get(`${(!!accData && Object.keys(accData).length > 0) ? 'marketprovider' : 'delaymarkets'}/markets/eventtype/${eventTypeId}`, null, options);
        //const response = await serviceContext.get(`marketprovider/markets`, null, options);

        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getEventsListForResult(event_type_id) {
    try {
        const response = await serviceContext.get(`${ReportsURL}findlastevent/${event_type_id}`, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getEventTreeList() {
    const accData = JSON.parse(localStorage.getItem("accountData"));    
    try {
        const response = await serviceContext.get(`${(!!accData && Object.keys(accData).length > 0) ? 'marketprovider' : 'delaymarkets'}/Markets/menu`, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
}

export async function getResultByEventID(event_id) {
    try {
        const response = await serviceContext.get(`${ReportsURL}findMarketResult/fromEventID/${event_id}`, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
}
